import { isAddress } from 'ethers/lib/utils';
import BaseService from '../commons/BaseService';
import { YLDRLeverageAutomations__factory } from './typechain/YLDRLeverageAutomations__factory';
export * from './types';
export class YLDRLeverageAutomations extends BaseService {
    constructor(context) {
        super(context.provider, YLDRLeverageAutomations__factory);
        if (!isAddress(context.leverageAutomateContractAddress)) {
            throw new Error('contract address is not valid');
        }
        this.contractInterface = YLDRLeverageAutomations__factory.createInterface();
        this.leverageAutomateContractAddress = context.leverageAutomateContractAddress;
        this._contract = YLDRLeverageAutomations__factory.connect(context.leverageAutomateContractAddress, context.provider);
    }
    setupCompoundTxData({ user, position, maxTotalFeePercent, }) {
        const tx = {};
        tx.from = user;
        tx.to = this.leverageAutomateContractAddress;
        tx.data = this.contractInterface.encodeFunctionData('setupCompound', [position, maxTotalFeePercent]);
        return tx;
    }
    cancelCompoundTxData({ user, position, }) {
        const tx = {};
        tx.from = user;
        tx.to = this.leverageAutomateContractAddress;
        tx.data = this.contractInterface.encodeFunctionData('cancelCompound', [position]);
        return tx;
    }
    setupRebalanceTxData({ user, position, triggerLower, triggerUpper, newTicksDown, newTicksUp, recurring, gasFeeConfig, }) {
        const tx = {};
        tx.from = user;
        tx.to = this.leverageAutomateContractAddress;
        tx.data = this.contractInterface.encodeFunctionData(
        // @ts-ignore
        'setupRebalance', [
            position,
            triggerLower,
            triggerUpper,
            newTicksDown,
            newTicksUp,
            [
                [
                    recurring.rangeConfig.rangeConfigType,
                    recurring.rangeConfig.ticksDown,
                    recurring.rangeConfig.ticksUp,
                    recurring.rangeConfig.sqrtPriceX96Down,
                    recurring.rangeConfig.sqrtPriceX96Up,
                ],
                [
                    recurring.endConfig.triggerType,
                    recurring.endConfig.count,
                    recurring.endConfig.timestamp,
                ],
                recurring.active,
            ],
            [
                gasFeeConfig.maxUsd,
                gasFeeConfig.maxPositionPercent,
            ]
        ]);
        return tx;
    }
    cancelRebalanceTxData({ user, position }) {
        const tx = {};
        tx.from = user;
        tx.to = this.leverageAutomateContractAddress;
        tx.data = this.contractInterface.encodeFunctionData('cancelRebalance', [position]);
        return tx;
    }
    setupDeleverageTxData({ user, position, triggerLower, triggerUpper, withdrawLiquidity, gasFeeConfig, }) {
        const tx = {};
        tx.from = user;
        tx.to = this.leverageAutomateContractAddress;
        tx.data = this.contractInterface.encodeFunctionData(
        // @ts-ignore
        'setupDeleverage', [
            position,
            triggerLower,
            triggerUpper,
            withdrawLiquidity,
            [
                gasFeeConfig.maxUsd,
                gasFeeConfig.maxPositionPercent,
            ]
        ]);
        return tx;
    }
    cancelDeleverageTxData({ user, position }) {
        const tx = {};
        tx.from = user;
        tx.to = this.leverageAutomateContractAddress;
        tx.data = this.contractInterface.encodeFunctionData('cancelDeleverage', [position]);
        return tx;
    }
    getConfiguredAutomations(positions) {
        return this._contract.getConfiguredAutomations(positions);
    }
}
//# sourceMappingURL=index.js.map